<template>
	<div>
		<v-dialog v-model="showdetailsdialog" hide-overlay transition="dialog-bottom-transition" fullscreen>
			<v-card class="details-wrapper">
				<div v-if="showdetailsdialog">
					<v-img class="event-thumbnail theme--dark v-sheet" :src="parseEventImage(event.image_url)" gradient="180deg, rgba(18,30,38,0.2) 0%, rgba(18,30,38,0.9) 70%">
						<div class="details-close-btn">
							<v-btn icon dark @click="closeDetails">
								<v-icon>close</v-icon>
							</v-btn>
						</div>
						<div class="event-content">
							<div class="event-content-inner">
								<v-card-title class="d-block">
									<div class="event-categories">
										<template v-for="(category, catkey) in event.event_type">
											<span class="event-category" v-if="category != 'Evente'" :key="catkey">{{ category }}</span>
										</template>
									</div>
									<h2 class="event-title">{{ event.name }}</h2>
								</v-card-title>
							</div>
						</div>
					</v-img>
					<div class="container">
						<div class="event-details-section">
							<div class="subheading event-details-section-title text-uppercase font-weight-bold"><v-icon>list</v-icon> {{ getStateWithParam('cityevents_details') }}</div>
							<div class="event-details-section-content" v-html="event.details"></div>
						</div>
						<v-divider class="event-details-section-divider"></v-divider>
						<div class="event-details-section">
							<div class="subheading event-details-section-title text-uppercase font-weight-bold"><v-icon>event</v-icon> {{ getStateWithParam('cityevents_datetime') }}</div>
							<template v-if="dateslist.length">
								<div v-for="date in dateslist" :key="date.id" class="event-details-section-content subheading">{{ date.range }}</div>
							</template>
							<div v-else class="event-details-section-content subheading">{{ event.dates.range }}</div>
						</div>
						<v-divider class="event-details-section-divider"></v-divider>
						<div v-if="event.location_name || event.location_address" class="event-details-section">
							<div class="subheading event-details-section-title text-uppercase font-weight-bold"><v-icon>place</v-icon> {{ getStateWithParam('cityevents_place') }}</div>
							<div class="event-details-section-content subheading">
								<div v-if="event.location_name">{{ event.location_name }}</div>
								<div>{{ event.location_address }}</div>
								<MapController v-if="maplocation" :fitbounds="fitbounds" style="margin-top: 20px; height: 300px !important">
									<l-marker :lat-lng="maplocation" :icon="getIconForMarker()"> </l-marker>
								</MapController>
							</div>
						</div>
						<v-divider class="event-details-section-divider"></v-divider>
						<div class="event-details-section">
							<div class="subheading event-details-section-title text-uppercase font-weight-bold"><v-icon>business</v-icon> {{ getStateWithParam('cityevents_organiser') }}</div>
							<div class="event-details-section-content">
								<div>{{ event.organier_name }}</div>
								<div v-if="event.organizer_address" class="subheading">{{ event.organizer_address }}</div>
								<div v-if="event.organizer_contact" class="subheading">{{ event.organizer_contact }}</div>
								<div style="margin-top: 10px; word-break: break-word" v-if="event.organizer_desc">{{ event.organizer_desc }}</div>
							</div>
						</div>
					</div>
				</div>
				<v-bottom-nav class="bottom-options" fixed>
					<!-- <v-btn color="primary" flat class="red--text"><v-icon>event</v-icon> Add to calendar</v-btn> -->
					<v-btn color="primary" flat @click="shareEvent" class="text-primary"><v-icon>share</v-icon> Share</v-btn>
				</v-bottom-nav>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import native_capacitor from '../../../config/js_helper/native_capacitor';
import DateUtils from '@/config/js_helper/DateUtils';
import MapController from '@/components/cards/MapController.vue';
import { LMarker } from 'vue2-leaflet';
import map_helper from '@/config/js_helper/map_helper.js';
export default {
	name: 'CityEventDetails',
	components: {
		MapController,
		LMarker,
	},
	props: {
		showdetailsdialog: { type: Boolean, default: false },
		event: { type: [Object], default: null },
	},
	data() {
		return {
			icon_url: require('@/assets/img/new_icons/my_location.svg'),
			fitbounds: 0,
		};
	},
	computed: {
		dateslist() {
			let list = [];
			if (this.event.repeats) {
				this.event.repeats.forEach((date) => {
					let start = DateUtils.unix(date[0]).utc();
					let end = DateUtils.unix(date[1]).utc();
					if (start.isSameOrAfter(DateUtils(), 'day')) {
						let dateobj = { id: date[0] };
						if (this.event.all_day_event === 'yes') {
							dateobj.range = start.format('dddd D MMMM YYYY') + ' (all day)';
						} else {
							dateobj.range = start.format('dddd D MMMM YYYY, HH:mm') + ' - ' + end.format('HH:mm');
						}
						list.push(dateobj);
					}
				});
			}
			return list;
		},
		maplocation() {
			let location = null;
			if (this.event.location_lat && this.event.location_lon) {
				location = [parseFloat(this.event.location_lat), parseFloat(this.event.location_lon)];
			}
			return location;
		},
	},
	watch: {
		showdetailsdialog() {
			this.$store.state.active_loader = false;
		},
	},
	mounted() {
		this.$nextTick(function () {
			this.fitbounds++;
		});
	},
	methods: {
		closeDetails() {
			//this.$router.push({name: 'cityevents'});
			this.$router.back();
		},
		parseEventImage(url) {
			let parsedurl = url;
			if (url) {
				parsedurl = url.replace('http://', 'https://');
			}
			return parsedurl;
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getIconForMarker() {
			return map_helper.getIcon(this.icon_url);
		},
		shareEvent() {
			native_capacitor.deviceShare({
				title: this.event.name,
				url: 'https://tiranaxxl.al/event/?p=' + this.event.id,
				dialogTitle: this.getStateWithParam('cityevents_share'),
			});
		},
	},
};
</script>

<style lang="scss">
.event-content {
	display: flex;
	align-items: flex-end;
	height: 100%;
	text-shadow: 0px 0px 50px black;
	.event-title {
		font-size: 2rem;
		line-height: 1.3;
		text-transform: uppercase;
	}
	.event-category {
		text-transform: uppercase;
		font-size: 0.8em;
		display: inline-block;
		margin-right: 5px;
	}
	.event-details {
		padding-top: 0 !important;
		font-weight: 400;
		.event-detail-item {
			display: flex;
			margin-bottom: 3px;
			//align-items: center;
			.event-detail-icon {
				margin-right: 10px;
			}
			.event-detail-value {
				padding-top: 2px;
				flex-grow: 1;
			}
		}
	}
}
.event-details-section {
	.event-details-section-title {
		margin-bottom: 16px;
	}
}
.event-details-section-content .wp-block-embed {
	width: 100%;
	height: 0;
	padding-bottom: 56.25%;
	position: relative;
}
.event-details-section-content {
	p:empty {
		display: none;
	}
	.wp-block-embed__wrapper {
		position: absolute;
		width: 100%;
		height: 100%;
		iframe {
			width: 100% !important;
			height: 100% !important;
		}
	}
}
.event-details-section-divider {
	margin-bottom: 16px;
}
.event-details-section {
	padding-bottom: 16px;
}
.details-close-btn {
	position: absolute;
	top: 0;
	right: 0;
}
.bottom-options {
	margin-bottom: 56px;
	.v-btn__content {
		flex-direction: column !important;
	}
}
.details-wrapper > div:not(.v-bottom-nav) {
	padding-bottom: 80px !important;
}
</style>
